import { SearchScenarioId } from 'owa-search-next-common';
import { action } from 'satcheljs';

const onSearchTextChangedInternal = action(
    'onSearchTextChangedInternal',
    (searchText: string, scenarioId: SearchScenarioId, showSuggestionsUi: boolean) => ({
        searchText,
        scenarioId,
        showSuggestionsUi,
    })
);

export default onSearchTextChangedInternal;
